var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFlash = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.773,
    height: 26.045,
    viewBox: "0 0 19.773 26.045",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.976,9.767H34.145l5.327-7.236A1.5,1.5,0,0,0,39.561.86,1.833,1.833,0,0,0,37.976,0H28.988a1.837,1.837,0,0,0-1.561.82l-7.19,11.4a1.5,1.5,0,0,0,.006,1.625,1.837,1.837,0,0,0,1.554.811h5.89l-5.653,8.96a1.531,1.531,0,0,0,.47,2.1,1.916,1.916,0,0,0,1.09.334,1.89,1.89,0,0,0,1.272-.477l14.38-13.023a1.517,1.517,0,0,0,.39-1.774A1.811,1.811,0,0,0,37.976,9.767ZM23.6,24.418,30.14,14.047v-.21a.859.859,0,0,0-.9-.814H21.8l7.19-11.4h8.988l-6.2,8.419a1.464,1.464,0,0,0-.206.534.859.859,0,0,0,.9.814h5.505Z",
    transform: "translate(-20.001)"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFlash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/flash.869dd62c.svg";
export { ForwardRef as ReactComponent };